/** Eligibility exposes tooling; it grants no authority to mutate a host session. */
export function isTuningEligible(developmentBuild: boolean, search: string): boolean {
  return developmentBuild || new URLSearchParams(search).has('debug');
}
